module.exports = __webpack_public_path__ + "img/IWarElephant64_ua.abab897f.webp";